import { useTranslation } from 'react-i18next';

import { AlertStyled } from 'theSource/components/Snackbar/SnackbarStyled';
import { PostElectionToastStyled } from './PostElectionToastStyled';
import { SnackbarSeverity } from 'theSource/components';
import { SNACKBAR_ICONS } from 'theSource/components/Snackbar/utils';

interface PostElectionToastProps {
  benefitLookupCode: string | undefined;
}

export const PostElectionToast = ({
  benefitLookupCode,
}: PostElectionToastProps) => {
  const { t } = useTranslation('messages.survey');
  const isSurvey = /^survey(_\d+)?$/i.test(benefitLookupCode ?? '');
  const message = isSurvey ? t('surveySaved') : t('addedToCart');

  return (
    <PostElectionToastStyled id="post-election-toast">
      <AlertStyled
        icon={SNACKBAR_ICONS['success' as SnackbarSeverity]}
        variant="filled"
        color="success"
        role="alert"
      >
        {message}
      </AlertStyled>
    </PostElectionToastStyled>
  );
};